import { IAppState } from "redux/reducers";
import React from "react";
import { IPage } from "api/entities/page";
import {
  DeletedConfigurationSortField,
  IDeletedConfigurationListItem,
  IDeletedConfigurationPageRequestParams,
} from "api/entities/deleted-config";
import Table, {
  IColumnDefinition,
  TableSelected,
} from "components/shared-ui/table/table";
import { connect } from "react-redux";
import { MoreOption } from "./more-options";
import { Formatters } from "helper/formatters";

const mapStateToProps = (state: IAppState) => ({
  accountType: state.users.currentUser.accountType,
});

export interface IArchiveTableProps extends ReturnType<typeof mapStateToProps> {
  isLoading: boolean;
  page: IPage<IDeletedConfigurationListItem>;
  requestParams: IDeletedConfigurationPageRequestParams;
  setRequestParams: (
    data: Partial<IDeletedConfigurationPageRequestParams>,
  ) => void;

  selection?: TableSelected<IDeletedConfigurationListItem>;
  onSelectionChanged?: (
    selection: TableSelected<IDeletedConfigurationListItem>,
  ) => void;
  onSelectAll?: () => void;

  isRowClickable?: boolean;
  hasManageColumn?: boolean;
}

export const ArchiveTable = connect(
  mapStateToProps,
  null,
)((props: IArchiveTableProps) => {
  const columns: IColumnDefinition<
    IDeletedConfigurationListItem,
    DeletedConfigurationSortField
  >[] = [
    {
      label: "Bucket",
      formatter: (row) => row.bucket,
      sortKey: DeletedConfigurationSortField.Bucket,
    },
    {
      label: "Expiration",
      formatter: (row) => Formatters.formatDateTime(row.expiredAt),
      sortKey: DeletedConfigurationSortField.ExpiredAt,
    },
    {
      label: "Status",
      formatter: (row) => row.status,
    },
    {
      label: "Deleted At",
      formatter: (row) => Formatters.formatDateTime(row.createdAt),
    },
  ];

  if (props.hasManageColumn) {
    columns.push({
      label: "Manage",
      formatter: (row) => <MoreOption data={row} />,
    });
  }

  return (
    <Table
      testId="shard-repository-table"
      hideCheckbox={!props.selection}
      columns={columns}
      rows={props.page.data}
      totalRows={props.page.count}
      loading={props.isLoading}
      requestParams={props.requestParams}
      onRequestParamsChanged={props.setRequestParams}
      // onRowClick={row => !!props.isRowClickable && }
      responsive={true}
      selected={props.selection}
      onSetSelected={props.onSelectionChanged}
      onSelectAll={props.onSelectAll}
    />
  );
});
